import { createAsyncAction, createAction } from "typesafe-actions";

import {
  DeleteEvalRunSuccess,
  EvalDatasetSummary,
  EvalRunDetail,
  EvalRunListResponse,
  EvalRunsFilter,
  EvalRunSubmitError,
  SubmitEvalRunPayload,
  SubmitEvalRunResponse,
} from "../interfaces";
import { EvaluationActionTypes } from "./constants";

export const getEvalRuns = createAsyncAction(
  EvaluationActionTypes.GET_EVAL_RUNS,
  EvaluationActionTypes.GET_EVAL_RUNS_SUCCESS,
  EvaluationActionTypes.GET_EVAL_RUNS_FAILURE,
)<EvalRunsFilter, EvalRunListResponse, Error>();

export const getEvalRun = createAsyncAction(
  EvaluationActionTypes.GET_EVAL_RUN,
  EvaluationActionTypes.GET_EVAL_RUN_SUCCESS,
  EvaluationActionTypes.GET_EVAL_RUN_FAILURE,
)<string, EvalRunDetail, Error>(); // payload = run uuid

// The failure payload is EvalRunSubmitError, not Error — the shared request client rejects with the
// wire's { code, message } body, never a real HTTP status, so the saga narrows that into this shape
// (see EvalRunSubmitError's own doc comment) rather than the bare Error every other domain uses.
export const submitEvalRun = createAsyncAction(
  EvaluationActionTypes.SUBMIT_EVAL_RUN,
  EvaluationActionTypes.SUBMIT_EVAL_RUN_SUCCESS,
  EvaluationActionTypes.SUBMIT_EVAL_RUN_FAILURE,
)<SubmitEvalRunPayload, SubmitEvalRunResponse, EvalRunSubmitError>();

export const deleteEvalRun = createAsyncAction(
  EvaluationActionTypes.DELETE_EVAL_RUN,
  EvaluationActionTypes.DELETE_EVAL_RUN_SUCCESS,
  EvaluationActionTypes.DELETE_EVAL_RUN_FAILURE,
)<string, DeleteEvalRunSuccess, Error>(); // payload = run uuid

export const getEvalDatasets = createAsyncAction(
  EvaluationActionTypes.GET_EVAL_DATASETS,
  EvaluationActionTypes.GET_EVAL_DATASETS_SUCCESS,
  EvaluationActionTypes.GET_EVAL_DATASETS_FAILURE,
)<void, EvalDatasetSummary[], Error>();

export const setFilter = createAction(EvaluationActionTypes.SET_FILTER)<EvalRunsFilter | null>();
// Payload-less deliberately: the saga's cancellable getEvalRun read is registered as
// takeLatest([getEvalRun.request, clearEvalRun], worker), and the worker's own action-type guard
// compares against clearEvalRun().type — that comparison only compiles, and only means anything, if
// this action never carries a payload.
export const clearEvalRun = createAction(EvaluationActionTypes.CLEAR_EVAL_RUN)();
export const clearEvalRuns = createAction(EvaluationActionTypes.CLEAR_EVAL_RUNS)();
